<template>
  <div :class="$attrs.class" v-if="isVisible">
    <div class="tw-mb-8">
      <h3 class="tw-text-3xl tw-font-bold tw-mb-2">
        Optional
      </h3>
    </div>

    <div class="tw-grid tw-gap-8 tw-grid-cols-2 tw-mb-8 ">  
      <Addon v-for="addon in addons"
        class="tw-px-8 tw-py-8 tw-bg-white tw-rounded-3xl tw-flex tw-items-center tw-justify-center tw-transition-all tw-cursor-pointer tw-shadow-lg"
        @addonToggled="toggleAddon"
        :key="'addon-'+addon.id"
        :addon="addon"
        :selected="selectedAddons.map(sel => sel.id).indexOf(addon.id) > -1" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, onMounted, computed, watch } from 'vue'
  import { useRouter } from 'vue-router'
  import type Product from '../../classes/Product';

  import Addon from './_Addon.vue';

  const props = defineProps<{ addons: Product[], selectedAddons: Product[] }>();
  const emit = defineEmits(['addonToggled'])

  const toggleAddon = ((addon: Product) => {
    emit('addonToggled', addon)
  })

  const isVisible = computed(() => {
    return props.addons && props.addons.length > 0;
  })
</script>
